import { sessionConstants } from '../constants';

export function sessionHistory(state = {}, action) {
  switch (action.type) {
    case sessionConstants.GETSESSION_HISTORY_REQUEST:
      return {
        loading: action.res
      };
    case sessionConstants.GETSESSION_HISTORY_SUCCESS:
      return {
        ...state,
        session: action.res,
        loading: false,
      };
    case sessionConstants.GETSESSION_HISTORY_FAILURE:
      return {
        error: action.error,
        loading: false
      };
    case sessionConstants.GETSESSION_FILTERED_SESSION_REQUEST:
      return {
        loading: action.res,
        isResponse: false
      };
    case sessionConstants.GETSESSION_FILTERED_SESSION_SUCCESS:
      return {
        session: action.res,
        loading: false,
      };
    case sessionConstants.GETSESSION_FILTERED_SESSION_FAILURE:
      return {
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/sessionHistory.reducer.js